module.exports = __webpack_public_path__ + "static/media/girl1.b2f91695.svg";